export default function() {
  return {
    item: {},
    items: [],
    pagination: {},
    widthMeasures: [],
    heightMeasures: [],
    rimMeasures: [],
    brands: [],
    models: [],
    years: [],
    version: [],
    vehicle: {}
  }
}
